import NewDateField from "../../DesignSystem/Inputs/NewDateField";
import NewInputField from "../../DesignSystem/Inputs/NewInputField";
import NewMobileNumberInput from "../../DesignSystem/Inputs/NewMobileNumberInput";
import RadioGroup from "../../DesignSystem/Inputs/RadioGroup";
import ReferenceForm from "./ReferenceForm";

const PERMISSION_OPTIONS = [
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
];

const AccountantReferenceDetails = ({
  form,
  update,
  validationErrors,
  isReferenceNotRequired = false,
}) => (
  <>
    <NewInputField label="Type of Reference" value="Accountant Reference" disabled />
    <div className="grid2 gap-m">
      <NewInputField
        label="Full Name"
        value={form.fullName}
        onChange={(event) => update("fullName", event.target.value)}
        required={!isReferenceNotRequired}
        error={validationErrors.fullName ? "Full Name is required." : ""}
      />
      <NewDateField
        label="Accountant Since"
        value={form.accountantFrom}
        onChange={(event) => update("accountantFrom", event.target.value)}
        required={!isReferenceNotRequired}
        error={validationErrors.accountantFrom}
        helperText={validationErrors.accountantFrom ? "Accountant Since is required." : ""}
      />
    </div>
    <NewMobileNumberInput
      label="Contact Number"
      value={form.contactNumber}
      onChange={(value) => update("contactNumber", value)}
    />
    <RadioGroup
      name="accountantAdviserPermission"
      label="Adviser’s permission to contact for reference"
      options={PERMISSION_OPTIONS}
      value={form.adviserPermission}
      onChange={(event) => update("adviserPermission", event.target.value)}
      required={!isReferenceNotRequired}
      inline
      error={validationErrors.adviserPermission}
      deselectable
    />
  </>
);

const AccountantReferenceForm = (props) => (
  <ReferenceForm
    {...props}
    referenceKind="accountant"
    DetailsFields={AccountantReferenceDetails}
  />
);

export default AccountantReferenceForm;
